import classnames from 'classnames';
import React, { ReactElement, ReactNode } from 'react';

interface TableBodyProps {
	children: ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

const TableBody = ({ children, className = '', style = null }: TableBodyProps) => {
	return (
		<div className={classnames('saola-scrollbar mt-2 max-h-48 overflow-y-scroll', className)} style={style}>
			{React.isValidElement(children)
				? React.cloneElement(children as ReactElement, {
						isTableHead: false,
					})
				: children}
		</div>
	);
};

export default TableBody;
